import React, { Component } from 'react'

import { Box, Button, Card, CardContent, Chip } from '@mui/material'
import queryString from 'query-string'
import { connect } from 'react-redux'
import type { RootState } from 'reducers'

import { loginMfa, me } from 'actions/auth-actions'
import { FormTextField } from 'components/input/'
import { withForm } from 'decorators/withForm'

type LoginMfaProps = {
  dirty: boolean
  handleSubmit: (...args: any[]) => any
  hasError: boolean
  hasFailed: boolean
  location: Record<string, any>
  loginMfa: (...args: any[]) => any
  me: (...args: any[]) => any
  navigate: (...args: any[]) => any
  submitting: boolean
}

class LoginMfa extends Component<LoginMfaProps> {
  onSubmit = async (values: any) => {
    const { location, loginMfa, navigate, me } = this.props
    // authAction never rejects — it resolves to the dispatched _FAIL action on a bad code, so check before navigating.
    const result = await loginMfa(values)
    if (result?.payload?.error) return
    await me()
    navigate(queryString.parse(location.search).next || '/')
  }

  renderErrorMessage = () => {
    const { dirty, hasError, hasFailed } = this.props
    if (dirty && hasError) return <Chip label="give it another go" sx={{ mb: '1rem' }} />
    if (dirty && hasFailed) return <Chip label="server error :(" sx={{ mb: '1rem' }} />
  }

  render() {
    return (
      <Box className="container container--narrow" sx={{ '& .form-text-field': { mb: '1rem' } }}>
        <Card>
          <CardContent>
            {this.renderErrorMessage()}
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
              <FormTextField fullWidth label="Enter one-time 2FA code" name="code" variant="outlined" />
              <Button color="primary" fullWidth loading={this.props.submitting} type="submit" variant="outlined">
                Submit
              </Button>
            </form>
          </CardContent>
        </Card>
      </Box>
    )
  }
}

export default connect(
  (s: RootState) => ({
    hasError: s.auth.hasError,
    hasFailed: s.auth.hasFailed,
    submitting: s.auth.submitting,
  }),
  { loginMfa, me },
)(
  withForm({
    form: 'loginMfa',
  })(LoginMfa),
)
